import { createApiClient, responseData } from '#lib/api/client.js';

export const getShopCart = async (
	fetchFn: typeof globalThis.fetch,
	productIds: string[]
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/cart/shop', {
			params: { query: { productIds: productIds.join(',') } },
		})
	);
